import React from 'react';
import {
  Wrapper,
  Box,
  Preview,
  TextBox,
  Text,
  Summary,
  SummaryDescription,
  TextDescription,
  Line,
  Shimmer,
  Rectangle
} from './styled';

export const PrintDetailShimmer: React.FC = () => (
  <Wrapper>
    <Rectangle width={60} height={20}><Shimmer /></Rectangle>
    <Box>
      <Preview>
        <Text>Vista previa de la publicación</Text>
        <TextBox>
          <Rectangle width={60}><Shimmer /></Rectangle>
          <Rectangle width={100}><Shimmer /></Rectangle>
          <Rectangle width={80}><Shimmer /></Rectangle>
          <Rectangle width={100}><Shimmer /></Rectangle>
        </TextBox>
      </Preview>
      <Summary>
        <Text>Resumen</Text>
        <Rectangle width={40}><Shimmer /></Rectangle>
        <SummaryDescription>
          <TextDescription position="left">
            <Rectangle width={40}>
              <Shimmer />
            </Rectangle>
          </TextDescription>
          <TextDescription position="right">
            <Rectangle width={20}>
              <Shimmer />
            </Rectangle>
          </TextDescription>
        </SummaryDescription>
        <SummaryDescription>
          <TextDescription position="left">
            <Rectangle width={80}>
              <Shimmer />
            </Rectangle>
          </TextDescription>
          <TextDescription position="right">
            <Rectangle width={20}>
              <Shimmer />
            </Rectangle>
          </TextDescription>
        </SummaryDescription>
        <Line />
        <SummaryDescription>
          <TextDescription>Sub Total</TextDescription>
          <TextDescription position="right">
            <Rectangle width={20}>
              <Shimmer />
            </Rectangle>
          </TextDescription>
        </SummaryDescription>
      </Summary>
    </Box>
  </Wrapper>
);


PrintDetailShimmer.displayName = 'PrintDetailShimmer';